/**
 * Compact status badge for group session lifecycle (SETUP → DECIDED).
 */
import type { GroupSessionStatus } from '../../types/prioritization/groupSession';

const STATUS_LABELS: Record<string, string> = {
  SETUP: 'Setup',
  OPEN: 'Open',
  SCORING: 'Scoring',
  REVEALING: 'Revealing',
  DECIDED: 'Decided',
};

const STATUS_COLORS: Record<string, { bg: string; color: string }> = {
  SETUP: { bg: 'var(--rule-bright)', color: 'var(--text-sec)' },
  OPEN: { bg: 'rgba(58,125,86,0.15)', color: 'var(--green)' },
  SCORING: { bg: 'var(--mustard-dim)', color: 'var(--mustard)' },
  REVEALING: { bg: 'var(--mustard-dim)', color: 'var(--mustard)' },
  DECIDED: { bg: 'var(--green-dim)', color: 'var(--green)' },
};

export function GroupSessionStatusPill({ status }: { status: GroupSessionStatus | string }) {
  const { bg, color } = STATUS_COLORS[status] ?? { bg: 'var(--rule)', color: 'var(--text-ter)' };
  return (
    <span
      className={status === 'OPEN' || status === 'DECIDED' ? 'dark:!text-[var(--text-ter)]' : undefined}
      style={{
        fontFamily: 'var(--mono)',
        fontSize: '11px',
        fontWeight: 600,
        letterSpacing: '0.06em',
        textTransform: 'uppercase',
        background: bg,
        color,
        padding: '4px 10px',
        borderRadius: '20px',
        whiteSpace: 'nowrap',
        flexShrink: 0,
        alignSelf: 'center',
      }}
    >
      {STATUS_LABELS[status] ?? status}
    </span>
  );
}
